/*
 * Copyright (c) Nexign, JSC, 2021.
 */
/**
 *
 *
 * @author Yakov Gushchin
 * @version 1.13.0
 * @since 1.12.0
 */

import styled from 'styled-components';

import { SelectDropContainerStyled } from '../../../../components/common/Select/styled/SelectDrop';
import { colors } from '../../../../theme';
import { IAttrStyled } from '../../../../types/globalTypes';

export const CashbackControlStyled = styled.div.attrs({
    className: 'cashback-control',
})`
    .cashback-control__group {
        display: flex;
        justify-content: space-between;
        flex-wrap: wrap;

        width: fit-content;
        min-width: 450px;
    }

    .cashback-control__score-balance {
        margin-bottom: 4px;
    }

    .cashback-control__score-balance-lost {
        .cashback-text {
            color: ${colors.textColorOpacity}
        }
    }

    .cashback-control__score-reserved {
        margin-top: 12px;
        margin-bottom: 24px;

        .cashback-text {
            display: flex;
            align-items: center;
        }

        .score-reserved__icon {
            margin-left: 10px;
        }
    }

    .cashback-control__score-distributed {
        display: flex;
        margin-bottom: 16px;
    }

    .cashback-control__score-info {
        max-width: 740px;
        margin-bottom: 32px;
    }
`;

export const CashbackControlTabContainerStyled = styled.div.attrs({
    className: 'cashback-control__tab-container',
})`
    .tab__header {
        border-bottom: 1px solid ${colors.pageDashboardBorderBottomNoActive};
    }

    .tab__item {
        flex-grow: initial;
    }

    .cashback-control__tab {
        display: none;
        position: relative;
        min-height: 200px;

        &.active {
            display: block;
        }
    }

    .cashback-control__tab-control {
        margin-top: 48px;
    }

    .cashback-control__cashback-services-info {
        margin-top: 56px;
    }

    .cashback-control__auto-spending-bonuses {
        margin-top: 56px;
    }
`;

export const CashbackServiceInfoStyled = styled.div.attrs(({ className }: IAttrStyled) => ({
    className: `cashback-services-info ${className || ''}`,
}))< IAttrStyled>`
    max-width: 740px;

    .cashback-services-info__title {
        margin-bottom: 12px;
    }

    .cashback-services-info__subtitle {
        margin-bottom: 24px;
    }

`;

export const CashbackControlServiceListStyled = styled.div.attrs({
    className: 'cashback-service-list',
})`
    display: grid;
    grid-template-columns: repeat(3, minmax(0, 1fr));
    grid-gap: 16px;
`;

export const CashbackNoServiceListStyled = styled.div.attrs({
    className: 'cashback-service-list_empty',
})`
    display: flex;
    flex-direction: column;
    justify-content: center;
    text-align: center;
`;


export const CashbackControlServiceCardStyled = styled.div.attrs(({ active }: { active: boolean }) => ({
    className: `cashback-service-card ${active ? 'cashback-service-card__active' : ''}`,
}))<{ active: boolean }>`

    width: 100%;
    display: flex;
    flex-direction: column;
    padding: 16px;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.16);
    cursor: pointer;
    user-select: none;
    border: 1px solid transparent;

    &.cashback-service-card__active {
        border-color: ${colors.backgroundColorSuccess}
    }

    .cashback-service-card__title {
        margin-bottom: 4px;
    }

    .cashback-service-card__reserved-label {
        color: ${colors.textColorOpacity}
    }

    .cashback-service-card__description {
        flex-grow: 1;
        margin-top: 12px;
        margin-bottom: 16px;
    }

    .cashback-service-card__link-more {
        display: inline;
        width: fit-content;
    }
`;

export const CashbackAutoSpendingBonusesStyled = styled.div.attrs(({ className, disabled }: IAttrStyled) => ({
    className: `auto-spending-bonuses ${className || ''} ${disabled ? 'disabled' : ''}`,
}))<{ disabled: boolean } & IAttrStyled>`
    max-width: 740px;

    .auto-spending-bonuses__title {
        margin-bottom: 12px;
    }

    .auto-spending-bonuses__subtitle {
        margin-bottom: 24px;
    }

    .auto-spending-bonuses__switch {
        display: inline-flex;
        cursor: pointer;

        .cashback-text {
            user-select: none;
            margin-left: 12px;
        }
    }

    &.disabled {
        .auto-spending-bonuses__switch {
            cursor: auto;
            pointer-events: none;

            .cashback-text {
                color: ${colors.textColorOpacity}
            }
        }
    }

`;

export const CashbackAccountSelectDropDownFilterButtonStyled = styled.div`
    display: flex;
    align-items: center;

    ${SelectDropContainerStyled} {
        width: auto;
    }
`;
